var VARS = {};

process.env.NODE_ENV === 'development' ?
	//DEVELOPMENT VARIABLES
	VARS = {
		//CLOUD_API_SERVER: 'https://sefconsulting.onlyoffice.eu/api/2.0',
		BACKEND_API_SERVER: 'http://localhost:3002/api',
		SSR_SERVER: 'http://localhost:3000/api'
	}
	:	//PRODUCTION VARIABLES
	VARS = {
		//CLOUD_API_SERVER: 'https://sefconsulting.onlyoffice.eu/api/2.0',
		BACKEND_API_SERVER: 'https://vintes.agrodig.it/be/api',
		SSR_SERVER: 'https://vintes.agrodig.it/api'
	}

export default VARS;
